import React, { useState } from "react";
import { TableBody, TableRow, TableCell, Button, Switch } from "@mui/material";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import { styled } from "@mui/material/styles";

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 39,
  height: 20,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 16,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(19px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(19px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        backgroundColor: "#1890ff",
        opacity: 1,
        border: 0,
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 16,
    height: 16,
    borderRadius: 16 / 2,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 20 / 2,
    opacity: 1,
    backgroundColor: "#E9E9EA",
    boxSizing: "border-box",
  },
}));

const soundsData = [
  { id: "Card-Shuffle", file: "FX-shuffle.mp3", enabled: true },
  { id: "Card-Pack-Open", file: "FX-pack.mp3", enabled: false },
  { id: "Coin-Win", file: "SFX-coin.mp3", enabled: true },
];

export default function SoundsTable({ searchTerm, sortConfig }) {
  const [sounds, setSounds] = useState(soundsData);

  const handleToggle = (index) => {
    const updatedSounds = [...sounds];
    updatedSounds[index].enabled = !updatedSounds[index].enabled;
    setSounds(updatedSounds);
  };

  const handleUpload = (index, event) => {
    const file = event.target.files[0];
    if (file) {
      const updatedSounds = [...sounds];
      updatedSounds[index].file = file.name;
      setSounds(updatedSounds);
    }
  };

  let filteredSounds = sounds.filter((sound) =>
    sound.id.toLowerCase().includes(searchTerm.toLowerCase())
  );

  if (sortConfig.key) {
    filteredSounds = [...filteredSounds].sort((a, b) => {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      if (aValue < bValue) return sortConfig.direction === "asc" ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }

  return (
    <TableBody
      sx={{
        "& td, & th": {
          color: "#6A707E",
          fontWeight: 500,
          fontSize: "16px",
        },
      }}
    >
      {filteredSounds.map((sound, index) => (
        <TableRow key={sound.id} sx={{ backgroundColor: "white" }}>
          <TableCell>{sound.id}</TableCell>
          <TableCell>
            <VolumeUpIcon sx={{ width: 24, height: 24 }} />
          </TableCell>
          <TableCell>{sound.file}</TableCell>
          <TableCell>
            <Button variant="contained" component="label" size="small">
              Upload SFX
              <input
                type="file"
                hidden
                onChange={(e) => handleUpload(index, e)}
              />
            </Button>
          </TableCell>
          <TableCell>
            <AntSwitch
              checked={sound.enabled}
              onChange={() => handleToggle(index)}
            />
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
}
